<template>
    <div class="container container-table">
        <div class="row">
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-solid box-info">
                        <div>
                            <div class="box-body">
                                <div class="row">
                                    <div style="width:224px;margin:auto;">
                                        <img src="../../src/assets/img/account/developer.png" class="center-block1">
                                    </div>
                                    <div style="test_all">
                                    <div class="text-center col-md-4 col-sm-offset-4 container">
                                        <!-- top form -->
                                        <form class="ui form loginForm container formRegionPosition">
                                            <h3 class="basic_form_h3">{{$t('basic_information')}}</h3>
                                            <div class="input-group">
                                                <span class="span_real_name">
                                                    {{$t('myAccount.form.basic.surname')}}
                                                    <span>{{importantStart}}</span>
                                                </span>
                                                <input @focus="inputfocus" :class="response ? input_border : ''" class="form-control input_form"  type="text" v-model="bodyAll.firstName" :onkeyPress="onkeyPress">
                                            </div>

                                            <div class="input-group">
                                                <span class="span_real_name">
                                                    {{$t('myAccount.form.basic.name')}}
                                                    <span>{{importantStart}}</span>
                                                </span>
                                                <input @focus="inputfocus" :class="response ? input_border : ''" class="form-control input_form"  type="text" v-model="bodyAll.lastName" :onkeyPress="onkeyPress">
                                            </div>

                                            <div class="input-group" >
                                                <span class="span_real_name">{{$t('developer_account_information_id')}}</span>
                                                <input :style="spacing" @focus="inputfocus" :class="response ? input_border : ''" class="form-control input_form" type="text" v-model="bodyAll.userId" :onkeyPress="onkeyPress">
                                            </div>

                                            <div class="input-group">
                                                <span class="span_real_name">
                                                    {{$t('phoneRegister')}}
                                                    <span>{{importantStart}}</span>
                                                </span>
                                                <input @focus="inputfocus" :class="response ? input_border : ''" class="form-control input_form"  type="text" v-model="bodyAll.phone" :onkeyPress="onkeyPress">
                                            </div>

                                             <div class="input-group div_position_country" v-show="!isInviteUser">
                                                <span class="span_real_name">
                                                    {{$t('developer_account_information_country')}}
                                                    <span>{{importantStart}}</span>
                                                </span>
                                                <div class="regionPositionBox" :authenticationRegion="'authenticationRegion'">
                                                    <div :authenticationRegion="'authenticationRegion'" :class="$store.state.globalSelectControlState !== 'authenticationRegion' ? 'border-radius-block-pub': 'border-radius-none-pub'" class="form-control regionClass">
                                                        <span :authenticationRegion="'authenticationRegion'" class="spanRegionText">{{regionSlected}}</span>
                                                        <img :authenticationRegion="'authenticationRegion'" class="imageRegion" src="../assets/img/header/btn_arrow_collapse_copy.png" alt="" />
                                                    </div>
                                                    <el-collapse-transition>
                                                        <ul class="imageRegionUl" v-show="$store.state.globalSelectControlState === 'authenticationRegion'">
                                                            <li v-for="(o, i) in regionArr" :key="i" @click="regionClickLiFunc(o)">
                                                                {{ o.i18n.description }}
                                                            </li>
                                                        </ul>
                                                    </el-collapse-transition>
                                                </div>
                                                <!-- <input :style="spacing" @focus="inputfocus" :class="response ? input_border : ''" class="form-control input_form" :placeholder="$t('countries')" type="text" v-model="bodyAll.region" :onkeyPress="onkeyPress"> -->
                                                <!-- <i class="i_country"><img src="../../src/assets/img/account/Authentication.gif" alt="" class="i_image"></i> -->
                                             </div>

                                        </form>
                                        <!-- bottom form -->
                                          <form class="ui form loginForm container form_company" v-show="!isInviteUser">
                                            <h3 class="company_form_h3">{{$t('company_job_information')}}</h3>
                                            <div class="input-group">
                                                <span class="span_real_name">
                                                    {{$t('developer_account_information_company_name')}}
                                                    <span v-show="isImportantStart">{{importantStart}}</span>
                                                </span>
                                                <input @focus="inputfocus" :class="response ? input_border : ''" class="form-control input_form"  type="text" v-model="bodyAll.companyName" :onkeyPress="onkeyPress">
                                            </div>

                                            <div class="input-group div_position_country" >
                                                <span class="span_real_name">{{$t('developer_account_information_category')}}</span>
                                                <input :style="spacing" @focus="inputfocus" :class="response ? input_border : ''" class="form-control input_form"  :placeholder="$t('select_category')" type="text" v-model="bodyAll.companyIndustry" :onkeyPress="onkeyPress">
                                                <i class="i_country"><img src="../../src/assets/img/account/Authentication.gif" alt="" class="i_image"></i>
                                             </div>

                                             <div class="input-group" >
                                                <span class="span_real_name">{{$t('developer_account_information_company_scale')}}</span>
                                                <input :style="spacing" @focus="inputfocus" :class="response ? input_border : ''" class="form-control input_form"   type="text" v-model="bodyAll.companyScale" :onkeyPress="onkeyPress">
                                             </div>

                                            <div class="input-group" >
                                                <span class="span_real_name">{{$t('developer_account_information_job_title')}}</span>
                                                <input :style="spacing" @focus="inputfocus" :class="response ? input_border : ''" class="form-control input_form"   type="text" v-model="bodyAll.companyOccupation" :onkeyPress="onkeyPress">
                                             </div>

                                            <div class="input-group" >
                                                <span class="span_real_name">{{$t('developer_account_information_website')}}</span>
                                                <input :style="spacing" @focus="inputfocus" :class="response ? input_border : ''" class="form-control input_form"   type="text" v-model="bodyAll.companyWebsite" :onkeyPress="onkeyPress">
                                             </div>
                                        </form>

                                        <div class="develop_plan_class" v-show="!isInviteUser">
                                            <h3 class="develop_plan_h3">{{$t('developer_account_information_develop_plan_title')}}</h3>
                                            <p class="develop_plan_p">{{$t('developer_account_information_develop_plan_text')}}</p>
                                            <div class="develop_plan_div">
                                                <textarea class="develop_plan_textarea" rows="行数" cols="列数" :placeholder="$t('write_plan')" v-model="planContent"></textarea>
                                            </div>
                                        </div>

                                        <div :class=" { red:changeRed == true } " class="div_creat_account" @click="creat_register_page" >
                                            <span class="span_creat_account">{{$t('submit_info')}}</span>
                                            <span class="span_creat_account_border" v-show="changeRed"></span>
                                        </div>

                                    </div>
                                    <div style="display:none;">{{ developerType }}</div>
                                    <LoginFooter/>
                                    </div>
                                </div>

                                <br/>

                            </div>

                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>
import api from '../api'
import config from '../config'
import LoginFooter from '@/views/LoginFooter.vue'

export default {
    name: 'Authentication',
    components: {
        LoginFooter
    },
    data (router) {
        return {
            section: 'Login',
            loading: '',
            response: '',
            spacing: '',
            input_border: 'input_border',
            checkbox_flag: false,
            changeRed: false,
            focus_flag: false,
            disabled: true,
            border_style: '',
            creat_account_flag: false,
            // [fu]
            bodyAll: {
                email: localStorage.user,
                firstName: '',
                lastName: '',
                type: '',
                userId: '',
                region: '',
                phone: '',
                companyName: '',
                companyOccupation: '',
                companyScale: '',
                companyWebsite: '',
                address: '',
                companyIndustry: '',
                wantMessage: true
            },
            planContent: '',
            onkeyPress: 'javascript:if(event.keyCode == 32)event.returnValue = false;',
            successForm: false,
            importantStart: '*',
            isImportantStart: false,
            isInviteUser: false,
            regionArr: [{ id: 1,
                i18n: [{ description: '中国', langCode: 'zh-CN' }, { description: '中國', langCode: 'zh-TW' }, { description: 'China', langCode: 'en' }]
            }, { id: 2,
                i18n: [{ description: '台湾', langCode: 'zh-CN' }, { description: '台灣', langCode: 'zh-TW' }, { description: 'Taiwan', langCode: 'en' }]
            }],
            regionSlected: '',
            copyArr: []
        }
    },
    created () {
        let developerType = localStorage.getItem('developerType')
        this.bodyAll.type = developerType
        if (this.bodyAll.type === 'company') {
            this.isImportantStart = true
        } else {
            this.isImportantStart = false
        }
    },
    mounted () {
        this.$store.state.isFooterShow = false
        let inviteEmail = localStorage.getItem('inviteEmail')
        let loginEmail = localStorage.getItem('login_email')
        if (inviteEmail === loginEmail) {
            this.isInviteUser = true
        }
        this.copyArr = JSON.parse(JSON.stringify(this.regionArr))
        this.filterI18n()
    },
    methods: {
        filterI18n () {
            let lang = this.$store.state.switchLanguage
            this.regionArr = this.regionArr.map((o, i) => {
                return {
                    id: o.id,
                    i18n: o.i18n.filter(o => o.langCode === lang)[0]
                }
            })
        },
        regionClickLiFunc (o) {
            this.bodyAll.region = o.id
            this.regionSlected = o.i18n.description
        },
        creat_register_page () {
            let { firstName, lastName, userId, phone, region, companyName, address, companyScale, companyOccupation, companyWebsite, companyIndustry } = this.bodyAll
            if (!firstName) {
                return
            }
            if (!lastName) {
                return
            }
            if (!userId) {
                // return
            }
            if (!phone) {
                return
            }
            if (!this.isInviteUser) {
                if (!region) {
                    return
                }
                if (!companyName) {
                    if (this.isImportantStart) return
                }
            }
            if (!address) {
                // return
            }
            if (!companyIndustry) {
                // return
            }
            if (!companyScale) {
                // return
            }
            if (!companyOccupation) {
                // return
            }
            if (!companyWebsite) {
                // return
            }
            this.detailedInformation()
        },
        reds () {
            this.changeRed = true
        },
        checkCreds () {
            this.focus_flag = false
            this.changeRed = true
            const { email } = this
            this.toggleLoading()
            this.resetResponse()
            this.$store.commit('TOGGLE_LOADING')

            const path = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerUserPrefix + config.developerApiLoginPrefix + config.developerApiVerify
            /* Making API call to authenticate a user */
            api.request('post', path, { email })
                .then(response => {
                    this.toggleLoading()
                    var data = response.data.data
                    /* Checking if error object was returned from the server */
                    if (data.error) {
                        var errorName = data.error.name
                        if (errorName) {
                            this.response = errorName === 'InvalidCredentialsError'
                                ? 'Your ID or password was entered incorrectly.'
                                : errorName
                        } else {
                            this.response = data.error
                        }
                        return
                    }

                    var token = 'Bearer ' + data.token
                    var user = data.email
                    this.$store.commit('SET_TOKEN', token)
                    this.$store.commit('SET_USER', user)
                    if (window.localStorage) {
                        window.localStorage.setItem('token', token)
                        window.localStorage.setItem('user', user)
                    }
                    this.$router.push({ name: 'listApp' })
                })
                .catch(error => {
                    this.$store.commit('TOGGLE_LOADING')
                    if (error.response && error.response.data && error.response.status >= 400) {
                        this.response = 'Your ID or password was entered incorrectly.'
                    } else {
                        this.response = 'Server appears to be offline'
                    }
                    this.toggleLoading()
                })
        },
        toggleLoading () {
            this.loading = (this.loading === '') ? 'loading' : ''
        },
        resetResponse () {
            this.response = ''
        },
        inputfocus () {
            this.resetResponse()
            this.focus_flag = true
        },
        detailedInformation () {
            const path = '/developer/user/account/:Id'
            let body = this.bodyAll
            if (this.planContent && !this.isInviteUser) {
                body.developDesc = this.planContent
            }
            if (this.isInviteUser) {
                delete body.type
                delete body.region
                delete body.companyName
                delete body.companyOccupation
                delete body.companyScale
                delete body.companyWebsite
            }
            // const headers = { 'authorization': this.$store.state.token }
            this._api.request('put', path, body)
                .then(response => {
                    if (response.status === 200) {
                        this.$store.state.borderStyle = 'file'
                        localStorage.setItem('clickState', 'file')
                        sessionStorage.setItem('registeredDetail', JSON.stringify(true))
                        this.$store.state.registeredDetail = 'true'
                        // this.$router.push({ name: 'listApp' })
                        this.$router.push({ name: 'MyProjectsList' })
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        trimFunc (str) {
            // return str.replace(/^(\s|\xA0)+|(\s|\xA0)+$/g, '')
            let regEx = /\s+/g
            let strA = str.replace(/^\s\s*/, '').replace(/\s\s*$/, '')
            return strA.replace(regEx, ' ')
        },
        trimOnlyFunc (str) {
            let i = str.indexOf(' ')
            if (i !== -1) {
                if (str.substring(i + 1, str.length).indexOf(' ') !== -1) {
                    this.section = '只能姓和名之间用一个空格隔开'
                } else {
                    this.section = '你是正确的'
                }
            }
        }
    },
    beforeUpdate () {
        // 使用生命周期函数 实现input框样式
        this.trimOnlyFunc(this.trimFunc(this.bodyAll.firstName))
        // 这是在判断 是否改变登陆按钮的颜色 是否禁用登陆按钮
        if (this.isInviteUser) {
            console.log('if')
            if (this.response || !this.bodyAll.firstName || !this.bodyAll.lastName || !this.bodyAll.phone) {
                this.changeRed = false
            } else {
                this.changeRed = true
            }
        } else if (this.isImportantStart) {
            console.log('else if')
            if (this.response || !this.bodyAll.companyName || !this.bodyAll.firstName || !this.bodyAll.region || !this.bodyAll.lastName || !this.bodyAll.phone) {
                this.changeRed = false
            } else {
                this.changeRed = true
            }
        } else {
            console.log('else')
            if (this.response || !this.bodyAll.firstName || !this.bodyAll.region || !this.bodyAll.lastName || !this.bodyAll.phone) {
                this.changeRed = false
            } else {
                this.changeRed = true
            }
        }
    },
    destroyed () {
        this.$store.state.isFooterShow = true
    },
    watch: {
        region (val, oldVal) {
            // console.log(val, oldVal) // 但是这两个值打印出来却都是一样的
        }
    },
    computed: {
        developerType () {
            return this.$store.state.developerType
        },
        region (val, oldVal) {
            return this.bodyAll.region
        }
    }
}
</script>

<style scoped>
    /* region */
    .spanRegionText {
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.2px;
    }
    .imageRegionUl > li {
        font-size: 14px;
        color: #333333;
        height: 28px;
        padding-top: 5px;
        /* line-height: 28px; */
        padding-left: 12px;
        box-sizing: border-box;
                    font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.2px;
    }
    .imageRegionUl > li:hover {
        background-color: rgba(0, 224, 218, 0.05);
        padding-top: 3px;
        box-sizing: border-box;
    }
    .imageRegionUl > li:active {
        color: #00b5e2;
    }
     .imageRegionUl > li:last-child {
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;
    }
    .formRegionPosition {
        position: relative;
        padding-bottom: 4em!important;
    }
    .regionPositionBox {
        position: absolute;
        left: 0px;
    }
    .regionBox {
        border: 1px solid rgba(51,51,51,0.5);
        border-radius: 12px;
    }
    .container .border-radius-none-pub {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom: none;
        transition: .05s;
    }
    .container .border-radius-block-pub {
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
        transition: 1.2s;
    }
    .imageRegionUl {
        padding: 0;
        width: 99.5%;
        margin: 0;
        list-style: none;
        background: #fff;
        border: 1px solid rgba(51,51,51,0.5);
        border-top: none;
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
    }
    .imageRegion {
        width: 12px;
        height: 7px;
    }
    .regionClass {
        height: 1.3em;
        width: 15.8em;
        border: 1.2px solid rgba(51,51,51,0.5);
        border-radius: 12px;
        margin: 0;
        color: #333333;
        display: flex;
        justify-content: space-between;
        align-items: center;
        /* position: relative; */
    }
    /* region */
    .span_creat_account_border{
        width: 406px;
        /* height: 2px; */
        border: solid 1.2px rgba(51, 51, 51, 0.3);
        position: absolute;
        bottom: 0px;
        right: 10px;
    }
    .div_position_country{
        position: relative;
    }
    .div_position_country:hover .i_country{
         transform: rotate(180deg);
         transform-origin:50% 50%;
         transition: .6s;
         top: 45px!important;
         bottom: 0px!important;
    }
    .i_country{
        width: 22px;
        height: 12px;
        position: absolute;
        right: 30px;
        bottom: 30px;
        z-index: 3;
    }
    .i_image{
        width: 100%;
        height: 100%;
        display: none;
    }
    .span_real_name{
        /* width: 344.3px; */
        width: 332.3px;
        height: 20px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: #333333;
        text-align: left;
        display: block;
        margin-bottom: 8px;
    }
    .develop_plan_textarea{
        width: 469px;
        height: 105px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: rgba(51, 51, 51, 0.3);
        display: block;
        margin: 0 auto;
        margin-top: 15px;
        border: none;
        outline: none;
    }
    .develop_plan_textarea::-webkit-input-placeholder{
        color: rgba(51, 51, 51, 0.3);
    }
    .develop_plan_div{
        width: 517px;
        height: 138px;
        border-radius: 10px;
        background-color: rgba(255, 255, 255, 0.6);
        border: solid 1px #00e0da!important;
        border: solid 1px var(--aqua-blue-two);
        margin: auto;
        margin-top: 26px;
        margin-bottom: 48px;
    }
    .develop_plan_h3{
        width: 133px;
        height: 29px;
        opacity: 0.8;
        font-family: sans-serif;
        font-size: 20px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.1px;
        color: #00b5e2!important;
        color: var(--aqua-blue);
        margin: auto;
        margin-top:36.8px;
        margin-bottom: 24px;
        text-align: center;
    }
    .develop_plan_p{
        width: 517px;
        /* height: 40px; */
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: #333333;
        text-align: left;
        margin: auto;
        font-family: LucidaGrande;
        font-weight: normal;
    }
    .basic_form_h3{
        width: 179px;
        height: 29px;
        opacity: 0.8;
        font-family: sans-serif;
        font-size: 20px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.1px;
        color: #00b5e2;
        margin: auto;
        margin-bottom: 28px;
        text-align: center;
    }
    .company_form_h3{
        width: 307px;
        height: 29px;
        opacity: 0.8;
        font-family: sans-serif;
        font-size: 20px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.1px;
        color: #00b5e2;
        margin: auto;
        margin-top: 9px;
        margin-bottom: 28px;
        text-align: center;
    }
    .div_agreement{
        width: 24em;
        height: 40px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        text-align: justify;
        color: #333333;
        margin: auto;
        margin-bottom:1em;
    }
    .Remember_me_image{
        width: 100%;
        height: 100%;
    }
    .div_creat_account{
        width: 430px;
        height: 78px;
        border-radius: 10px;
        /* background-color: #00b5e2!important; */
        background-color: rgba(51, 51, 51, 0.2);
        /* border: solid 2.5px rgba(0, 181, 226, 0.5); */
        border: none;
        margin: auto;
        cursor: pointer;
        /* margin-bottom: 2.7em; */
        position: relative;
        text-align: center;
    }
    .span_creat_account{
        width: 21.4em;
        height: 2.35em;
        font-family: sans-serif;
        font-size: 22px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.2px;
        text-align: center;
        color: #ffffff;
        line-height: 3.5em;
    }
    .error_response_p{
        margin:0;
    }
    .input_error_response{
        width: 23.8em;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: rgba(246, 70, 53, 0.5);
        padding-bottom: 3.7em;
        margin: auto;
        text-align: left;
        margin-top: -.6em;
    }
    .label_class{
          width: 1.7em;
          height: 1.8em;
          border: 1px solid #00b5e2;
          border-radius: 2px;
          margin-top: -.3em;
          cursor: pointer;
    }
    .red{
         background-color: #00b5e2!important;
         opacity: 1!important;
        }
    .btn_signin{
        width: 10em;
        height: 2.4em;
        outline: none;
        border: 2px solid #00b5e2;
        background: white;
        color:#00b5e2;
        font-size: 22px;
        cursor: pointer;
        border-radius: 10px;
        letter-spacing: 1.2px;
        font-weight: bold;
    }
    .btn_login{
        width: 10em;
        height: 2.4em;
        outline: none;
        border: 0;
        border-radius: 10px;
        font-size: 22px;
        margin-bottom: 1em;
        letter-spacing: 1.2px;
        font-weight: bold;
        cursor: pointer!important;
        background-color: rgba(51, 51, 51, 0.2);
        color: #ffffff;
        opacity: 0.5;
    }
    .loading{
        font-size:18px;
    }
    .btnStyle{
        background: #00b5e2;
        color: #ffffff;
    }
    .input_border{
        border-color: #f64635!important;
        color: #f64635!important;
    }
    html, body, .container-table {
        height: 100%;
        background-color: white !important;
    }
    .container-table {
        display: table;
        color: white;
        width:72%;
    }
    .vertical-center-row {
        display: table-cell;
        vertical-align: middle;
    }
    .vertical-20p {
        padding-top: 20%;
    }
    .vertical-10p {
        padding-top: 10%;
    }
    .logo {
        width: 15em;
        padding: 3em;
    }
    .loginForm .input-group {
        padding-bottom: 1em;
        height: 0;
    }
    .input-group input {
        height: 2.7em;
    }
    #userLoginSubmitButton {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
        height: 100%;
        outline: none;
    }
    /* [fu] */

    /* 取消边框 */
    .box.box-solid.box-info{
        border:none;
    }
    .vertical-10p{
       padding-top: 3.5em!important;
    }
    .center-block1 {
       padding-bottom: 3.5em!important;
       margin-top: 50px;
    }
    .box-body{
        padding-top: 0;
    }
    /* input */
    .input-group input{
        width: 23.8em!important;
        border-radius: 12px!important;
        border: 1px solid rgba(51,51,51,0.5);
        color: #333333;
    }
    .input-group{
        margin: auto;
        font-weight: bold;
    }
    /* form剧中 */
    .col-sm-offset-4{
        /* margin-left: 23%;
         */
         margin: auto;
         width: 100%;
    }
    .checkbox_div{
        display: flex;
        margin-left: 2em;
        margin-bottom: 3.5em;
        width: 23.8em;
        margin: auto;
        padding-bottom: 2.8em;
        /* margin-top: -.5em; */
        position: relative;
    }
    /* 这是button */
    .btn-info{
        background-color: rgba(51,51,51,0.2);
        border: none;
        width: 10em!important;
        margin-left: 33%;
        border-radius: 8px!important;
        font-size: 22px!important;
        height: 50px!important;
        margin-bottom: 1.5em!important;
        margin:auto;
    }
    .div_signin{
        width: 37em;
        padding-top:2.7em;
        margin:auto;
    }

    /* input的字体大小 */
    .form-control{
        padding: 6px 24px;
        font-size: 18px;
    }
    .Forget_password{
        height: 20px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: #333333;
    }
    .Remember_me{
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: 19px;
        letter-spacing: 0.8px;
        color: #333333;
        padding-left: 10px;
    }
    .Remember_me{
        cursor: pointer;
    }
    .checkbox_class{
        cursor: pointer;
    }
    .Forget_password{
        cursor: pointer;
    }
    /* 加form的上下border */
    .ui{
        width: 37em;
        border-bottom: 2px solid rgba(0,224,218,0.3);
        border-top: 2px solid rgba(51, 51, 51, 0.1);
        padding-top: 2.7em;
        padding-bottom: 34px;
    }
    .form_company{
            border-top: none;
        }
    .box{
        box-shadow: none;
        margin-bottom: 0;
    }
    .box-body{
        padding-bottom: 0;
    }
    .Join-NUWA-developer{
        width: 164px;
        height: 20px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: rgba(51, 51, 51, 0.5);
        /* text-align: center; */
        margin: auto;
        padding-top: 2.6em;
    }

    /* 底部 */
    .Copyright-2018-Nuw{
        width: 400px;
        height: 20px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        margin-left: 1em;
        color: #333333;
    }
    .copyright_a{
        color: #333333;
    }
    .Login-Page_Link{
        /* width: 98px; */
        height: 20px;
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: #333333;
    }
    .Login-Page_Link a{
        padding: 0 18px;
        color: #333333;
    }
    .Login-Page_Link a:not(:last-child){
        border-right: 1px solid;
    }
    .input_form{
        width: 380px;
        /* height: 34px; */
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.2px;
        color: rgba(51, 51, 51, 0.3);
    }
    .div_footer{
        display:flex;
        clear:both;
        margin:auto;
        padding-top: 8.2em;
        width: 57em;
    }
    #app{
        background: rgba(0, 181, 226, 0.1);
    }

     /* [新增] */
    .container {
        /* padding-right: 15px;
        padding-left: 15px;
        margin-right: auto;
        margin-left: auto; */
        margin: auto;
    }
    .label_class{
        width: 21.8px;
        height: 23.2px;
    }
    .input-group {
        position: relative;
        display: table;
        border-collapse: separate;
    }
    .btn_signin{
        display: block;
        margin: auto;
    }
    .Join-NUWA-developer{
        text-align: center;
    }
    .input-group input{
        outline: none;
        height: 1.7em!important;
        width: 20.2em!important
    }
    .checkbox_div{
        width: 20.2em!important;
    }
    /* 新增 */
</style>
